class CarbonWorldVideo extends HTMLElement {
  #observer = null;
  #loaded = false;

  connectedCallback() {
    const video = this.querySelector('video');

    if (!video) {
      return;
    }

    this.#observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];

        if (!entry?.isIntersecting) {
          return;
        }

        this.#loadVideo(video);
        this.#observer?.disconnect();
        this.#observer = null;
      },
      {
        rootMargin: '200px 0px',
        threshold: 0.15
      }
    );

    this.#observer.observe(this);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#observer = null;
  }

  #loadVideo(video) {
    if (this.#loaded) {
      return;
    }

    this.#loaded = true;

    video.querySelectorAll('source[data-src]').forEach((source) => {
      if (source.dataset.src) {
        source.src = source.dataset.src;
      }
    });

    video.load();

    const playPromise = video.play();

    if (playPromise && typeof playPromise.then === 'function') {
      playPromise
        .then(() => {
          this.classList.add('is-playing');
        })
        .catch(() => {
          this.classList.add('is-playing');
        });
    } else {
      this.classList.add('is-playing');
    }
  }
}

if (!customElements.get('carbon-world-video')) {
  customElements.define('carbon-world-video', CarbonWorldVideo);
}
